import React, { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { LuClock3 } from "react-icons/lu";
import Loader from "../Loader";
import { AiConformationModal } from "../ModalPopup/AiConfirmationModal";
import { useDispatch, useSelector } from "react-redux";
import { createRegenResearchContentStart, createResearchContentStart, getRegenResearchContentStart, getResearchContentStart } from "../../Store/Slices/promptSlice";

const ResearchContent = ({
    showAiResponseModal,
    setShowAiResponseModal,
    selectedRowAiResponse,
    generatedData,
    id,
    selectedRowDataToReGnerate,
    currentUserData,
    moduleName,
    rowAllData
}) => {
    const dispatch = useDispatch();
    let promptData = useSelector((state) => state?.prompt);
    let [showAiConfirmationModal, setShowAiConfirmationModal] = useState(false);
    let [isResponseGenerated, setIsResponseGenerated] = useState(false);
    let [isShowGenerateContent, setIsShowGenerateContent] = useState(false);
    let [isRegenerateEnabled, setIsRegenerateEnabled] = useState(false);

    const getDynamicContent = (content) => {
        if (moduleName === 'Prospects') {
            content = content.replaceAll('${Leads.Company}', selectedRowDataToReGnerate?.Company_Name);
        }
        if (moduleName === 'Leads') {
            content = content.replaceAll('${Leads.Company}', selectedRowDataToReGnerate?.Company);
        }
        if (moduleName === 'Accounts') {
            content = content.replaceAll('${Leads.Company}', selectedRowDataToReGnerate?.Account_Name);
        }
        content = content.replaceAll('${Company}', currentUserData?.organization?.organizationName);
        return content;
    }
    useEffect(() => {
        if (isResponseGenerated) {
            setIsShowGenerateContent(true)
            setIsRegenerateEnabled(false);
            const headingsArr = promptData?.data?.[0]?.prompt_list
                .filter(item => item.is_include)
                .map(item => item.key);
            // let content = getDynamicContent(promptData?.data?.[0]?.generated_prompt)
            let aiPrompt = getDynamicContent(promptData?.data?.[0]?.generated_prompt)
            let researchPrompt = getDynamicContent(promptData?.data?.[0]?.assistant_prompt)
            let payload = {
                "moduleId": id,
                "formModuleId": selectedRowDataToReGnerate?._id,
                "home_company": currentUserData?.organization?.organizationName,
                // "customer_company": selectedRowDataToReGnerate?.Company,
                "headings": headingsArr,
                "research_prompt": researchPrompt,
                "ai_prompt": aiPrompt,
                // "to_email": selectedRowDataToReGnerate?.Email
            }
            if (moduleName === 'Prospects') {
                payload['customer_company'] = selectedRowDataToReGnerate?.Company_Name
                const primaryEmail = rowAllData?.data?.find((section) => section?.section_data?.table_data)?.section_data?.table_data?.find((row) => row.Email_isPrimary === true)?.Email;
                payload['to_email'] = primaryEmail || selectedRowDataToReGnerate?.Email || '';
            }
            if (moduleName === 'Leads') {
                payload['customer_company'] = selectedRowDataToReGnerate?.Company
            }
            if (moduleName === 'Accounts') {
                payload['customer_company'] = selectedRowDataToReGnerate?.Account_Name
            }
            dispatch(createRegenResearchContentStart(payload))
        }
    }, [isResponseGenerated])

    useEffect(() => {
        if (promptData.generateStatus) {
            setIsResponseGenerated(false)
            setIsShowGenerateContent(false)
            setIsRegenerateEnabled(true);
            if (id?.length > 0) {
                dispatch(getRegenResearchContentStart(id))
            }
        }
    }, [promptData.generateStatus])

    return (
        <React.Fragment>
            <Offcanvas placement='end'
                show={showAiResponseModal}
                onHide={() => { setShowAiResponseModal(false); }}
                className="email-composer timeline-offcanvas"
                backdrop={true}
                scroll={false}>
                <Offcanvas.Header closeButton className="pb-2 position-relative">
                    <Offcanvas.Title>Generated Report</Offcanvas.Title>
                    <button type="button" title="ReGenerate" class="ms-3 btn px-2 rounded-2 btn-digy-dark-outline"
                        onClick={() => setShowAiConfirmationModal(true)} >
                        {/* <i class="fa fa-history"></i> */}
                        <LuClock3 className="cursor-pointer" />
                    </button>
                    {/* <LuClock3 className="cursor-pointer" /> */}
                </Offcanvas.Header>
                <Offcanvas.Body className="vh-100" style={{ overflow: 'scroll' }}>
                    <Loader isVisible={isShowGenerateContent || promptData?.isRegenLoading} isModal={true} overall={false} isShowGenerateContent={isShowGenerateContent} />
                    {isRegenerateEnabled ?
                        <div dangerouslySetInnerHTML={{ __html: promptData?.researchData?.filter((data) => data.formModuleId === selectedRowDataToReGnerate?._id)?.[0]?.html_content }}></div>
                        :
                        <div dangerouslySetInnerHTML={{ __html: selectedRowAiResponse?.html_content }}></div>
                    }
                    {/* {isRegenerateEnabled ?
                        <div dangerouslySetInnerHTML={{ __html: promptData.generatedData?.html_content }}></div>
                        :
                        <div dangerouslySetInnerHTML={{ __html: selectedRowAiResponse?.html_content }}></div>
                    } */}
                </Offcanvas.Body>
            </Offcanvas>

            {
                showAiConfirmationModal &&
                <AiConformationModal
                    showAiConfirmationModal={showAiConfirmationModal}
                    setShowAiConfirmationModal={setShowAiConfirmationModal}
                    setIsResponseGenerated={setIsResponseGenerated}
                    type="Regenerate"
                />
            }
        </React.Fragment >
    )
}
export default ResearchContent;